import {
  AnchorValue,
  CategoriesWrapper,
  Category,
  CategoryContainer,
  CategoryHeader,
  DetailRow,
  Label,
  MainContainer,
  MapContainer,
  Pill,
  PillNumber,
  QualityCareContainer,
  QualityCareDetailRow,
  QualityCareTitle,
  QualityCareValue,
  RoundedBorder,
  ScrollWrapper,
  Section,
  SectionSpan,
  SectionTitle,
  SpanTag,
  SpanValue,
  Tag,
  TagContainer,
  TagWithBadge,
  Value,
} from "./index.styled";
import FactSheetTopBanner from "../FactSheetTopBanner";
import { ReactComponent as MedalIcon } from "../../Assets/Icons/Medal-Icon.svg";
import { transformDataForFrontend } from "./dataHandler";
import { viewSizeCalculator } from "../../utils";

const FactSheetLeft = ({ data, state, toggleState }) => {
  const {
    hospitals,
    facilities,
    financials,
    affiliations,
    accreditations,
    oncology_focus,
    oncology_research,
    accessibility_inclusivity,
    quality_of_care,
    patient_experience,
  } = transformDataForFrontend([data]);
  
  const validAffiliations = affiliations.filter((item) => item.values !== "-");

  const sortedQualityOfCare = [...quality_of_care].sort((a, b) => {
    if (a.label === "Overall Rating") return -1;
    if (b.label === "Overall Rating") return 1;
    return 0;
  });

  function normalizeAccreditations(data) {
    return data.map((item) => {
      if (item.label === "Accreditations") {
        if (
          item.values.length === 1 &&
          Array.isArray(item.values[0]) &&
          item.values[0].length === 1 &&
          typeof item.values[0][0] === "string"
        ) {
          // Case: [['string,with,commas...']] → split into array
          const splitValues = item.values[0][0].split(",").map((s) => s.trim());
          item.values = [splitValues];
        }
        // Else: Already in correct format [["item1", "item2", ...]]
      }
      return item;
    });
  }

  const normalizedAccreditationsData = normalizeAccreditations(accreditations);

  const formatValueWithCustomSuffix = (value) => {
    if (value === null || value === undefined || value === '' || value === "-") return '-';
  
    let strValue = value.toString().trim();
  
    let isNegative = strValue.startsWith('-');
    if (isNegative) {
      strValue = strValue.substring(1);
    }
  
    const suffixMatch = strValue.match(/([^a-zA-Z]*)([a-zA-Z]+)$/);
    if (suffixMatch) {
      const [, numberPart, suffix] = suffixMatch;
      const formattedValue = (
        <>
          {isNegative ? `(${numberPart}` : numberPart}
          <SpanValue isNegative={value?.toString().startsWith('-') && value !== '-'}
            isPlaceholder={value === null || value === undefined || value === '' || value === '-'}>{suffix}</SpanValue>
          {isNegative ? `)` : ""}
        </>
      );
      return formattedValue;
    }
  
    return isNegative ? `(${strValue})` : strValue;
  };

  return (
    <MainContainer>
      <FactSheetTopBanner data={data} toggleState={toggleState} state={state} />
      <ScrollWrapper>
        <Section>
          <RoundedBorder />
          <SectionTitle>Facility</SectionTitle>
          <CategoriesWrapper>
            {Array.isArray(facilities) &&
              facilities
                .filter(
                  (item) =>
                    item.label !== "Teaching Status" &&
                    item.values.some((value) => value !== "-"),
                )
                .map((item) => (
                  <DetailRow key={item.label}>
                    <Label>{item.label}</Label>
                    {item.values
                      .filter((value) => value !== "-")
                      .map((value) => {
                        return (
                          <Value key={value}>
                            <span
                              style={{
                                display: "inline-block",
                                maxWidth: viewSizeCalculator(17),
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {item.label === "Discharges" && !isNaN(value)
                                ? new Intl.NumberFormat("en-US").format(
                                    Math.round(value),
                                  )
                                : value}
                            </span>
                          </Value>
                        );
                      })}
                  </DetailRow>
                ))}

            {Array.isArray(facilities) &&
              facilities
                .filter(
                  (item) =>
                    item.label === "Teaching Status" &&
                    item.values.some((value) => value !== "-"),
                ) // Ensure "Teaching Status" has valid values
                .map((item) => (
                  <DetailRow key={item.label}>
                    <Label>{item.label}</Label>
                    {item.values
                      .filter((value) => value !== "-")
                      .map((value) => (
                        <Value key={value}>{value ? "Yes" : "No"}</Value>
                      ))}
                  </DetailRow>
                ))}
          </CategoriesWrapper>
        </Section>
        <Section>
          <RoundedBorder />
          <SectionTitle>Financial & Operational Metrics</SectionTitle>
          <CategoryContainer>
            <Category>
              {/* <CategoryHeader>Revenue</CategoryHeader> */}
              <CategoriesWrapper>
                {financials
                  .filter((item) => item.label !== "Revenue to Cost Ratio")
                  .map((item) => (
                    <DetailRow key={item.label}>
                      <Label>{item.label}</Label>
                      {item.values
                        // .filter((value) => value !== "-") // Exclude "-" values before rendering
                        .map((value) => (
                          <Value
                            isNegative={value?.toString().startsWith('-') && value !== '-'}
                            isPlaceholder={value === null || value === undefined || value === '' || value === '-'}
                          >
                            {formatValueWithCustomSuffix(value)}
                          </Value>
                        ))}
                    </DetailRow>
                  ))}
              </CategoriesWrapper>
            </Category>

            {/* <Category>
              <CategoryHeader>Cost</CategoryHeader>
              <CategoriesWrapper>
                {financials
                  .filter((item) => item.label === "Revenue to Cost Ratio")
                  .map((item) => (
                    <DetailRow key={item.label}>
                      <Label>{item.label}</Label>
                      {item.values.map((value) => (
                        <Value key={value}>{value}</Value>
                      ))}
                    </DetailRow>
                  ))}
              </CategoriesWrapper>
            </Category>

            <Category>
              <CategoryHeader>Bad Debt %</CategoryHeader>
              <CategoriesWrapper>
                {financials
                  .filter((item) => item.label === "Bad Debt Percentage")
                  .map((item) => (
                    <DetailRow key={item.label}>
                      <Label>{item.label}</Label>
                      {item.values.map((value) => (
                        <Value key={value}>{value}</Value>
                      ))}
                    </DetailRow>
                  ))}
              </CategoriesWrapper>
            </Category> */}
          </CategoryContainer>
        </Section>
        {validAffiliations.length > 0 && (
          <Section>
            <RoundedBorder />
            <SectionTitle>Affiliations</SectionTitle>
            {/* <TagContainer>
              {affiliations[0].values[0].map((item) => (
                <Tag key={item}>{item}</Tag>
              ))}
            </TagContainer> */}
            <QualityCareContainer>
              {affiliations.map((item) => (
                <QualityCareDetailRow key={item.label}>
                  <QualityCareTitle>{item.label}: </QualityCareTitle>
                  <QualityCareValue>{item.values}</QualityCareValue>
                </QualityCareDetailRow>
              ))}
            </QualityCareContainer>
            {/* <TagContainer>
              <SpanTag>-</SpanTag>
            </TagContainer> */}
          </Section>
        )}
        <Section>
          <RoundedBorder />
          <SectionTitle>Accreditations</SectionTitle>
          <TagContainer>
            {normalizedAccreditationsData[0].values[0].map((item) => (
              <Tag key={item}>{item}</Tag>
            ))}
          </TagContainer>
          {/* <TagContainer>
            {accreditations.some((item) => item.values === true) ? (
              accreditations
                .filter((item) => item.values === true)
                .map((item) => (
                  <Tag key={item.label}>
                    <MedalIcon /> <SpanTag>{item?.label}</SpanTag>
                  </Tag>
                ))
            ) : (
              <SpanTag>-</SpanTag>
            )}
          </TagContainer> */}
        </Section>
        <Section>
          <RoundedBorder />
          <SectionTitle>
            Oncology Focus - Procedure Volume{" "}
            <SectionSpan>(2023).</SectionSpan>{" "}
          </SectionTitle>
          <CategoryContainer>
            <Category>
              <CategoriesWrapper>
                {oncology_focus
                  .filter(
                    (item) => item.values !== "-", // Ensures value is not "-"
                  )
                  .map((item) => (
                    <DetailRow key={item.label}>
                      <Label>{item.label}</Label>
                      {item.label !== "Procedures" && (
                        <Value>{item.values}</Value>
                      )}
                      {item.label == "Procedures" && (
                        <Value>{item.values}</Value>
                      )}
                    </DetailRow>
                  ))}
              </CategoriesWrapper>
            </Category>
          </CategoryContainer>
          {/* <TagContainer>
            {oncology_focus.some((item) => item.values === true) ? (
              oncology_focus
                .filter((item) => item.values === true)
                .map((item) => <Tag key={item.label}>{item?.label}</Tag>)
            ) : (
              <SpanTag>-</SpanTag>
            )}
          </TagContainer>
          <TagContainer>
            {oncology_focus.some((item) => item.values > 0) &&
              oncology_focus
                .filter((item) => item.values > 0)
                .map((item) => <Tag key={item.label}>{item.label}</Tag>)}
          </TagContainer> */}
        </Section>
        {/* <Section>
          <RoundedBorder />
          <SectionTitle>Oncology Research</SectionTitle>
          <TagContainer>
            {oncology_research.some((item) => item.values === true) ? (
              oncology_research
                .filter((item) => item.values === true)
                .map((item) => <Tag key={item.label}>{item?.label}</Tag>)
            ) : (
              <SpanTag>-</SpanTag>
            )}
          </TagContainer>
        </Section> */}

        {quality_of_care.length > 0 && (
          <Section>
            <RoundedBorder />
            <SectionTitle>Quality of Care</SectionTitle>
            <TagContainer>
              {sortedQualityOfCare.map((item) => {
                let displayValue = item.values;

                // Handle booleans (c4qi / nccn)
                if (typeof item.values === "boolean") {
                  return (
                    <TagWithBadge key={item.label}>
                      {item.label}
                      <Pill status={item.values}>
                        <span>{item.values ? "Yes" : "No"}</span>
                      </Pill>
                    </TagWithBadge>
                  );
                }

                // Handle missing values -> just star with gray pill
                if (
                  !displayValue ||
                  displayValue === "-" ||
                  displayValue === "undefined" ||
                  displayValue === "None" ||
                  displayValue === "None%"
                ) {
                  return (
                    <TagWithBadge key={item.label}>
                      {item.label}
                      <Pill status={null}>
                        <span>N/A</span>
                      </Pill>
                    </TagWithBadge>
                  );
                }

                // Otherwise show value + star
                return (
                  <TagWithBadge key={item.label}>
                    {item.label}
                    <Pill status={item.values}>
                      <span>{item.values} ★</span>
                    </Pill>
                  </TagWithBadge>
                );
              })}
            </TagContainer>
          </Section>
        )}

        {/* <Section>
          <RoundedBorder />
          <SectionTitle>Patient Experience</SectionTitle>
          <TagContainer>
            {patient_experience.every((item) => item.values === "-") ? (
              <SpanTag>-</SpanTag>
            ) : (
              <>
                {patient_experience
                  .filter(
                    (item) =>
                      item.label === "Appointment Wait Times" &&
                      item.values !== "-",
                  )
                  .map((item) => (
                    <TagWithBadge key={item.label}>
                      {item.label}
                      <Pill
                        status={
                          item.values.toLowerCase() === "low" ? true : false
                        }
                        bg={item.values === "-" ? "#F34D4D" : undefined}
                      >
                        <span>{item.values === "-" ? "-" : item.values}</span>
                      </Pill>
                    </TagWithBadge>
                  ))}

                {patient_experience
                  .filter(
                    (item) =>
                      item.label == "Cancer Navigation Program" &&
                      item.values !== "-",
                  )
                  .map((item) => (
                    <TagWithBadge>
                      {item.label}
                      <Pill
                        status={item.values !== "-" && item.values}
                        bg={item.values === "-" ? "#F34D4D" : undefined}
                      >
                        <span>
                          {item.values === "-"
                            ? "-"
                            : item.values
                              ? "Yes"
                              : "No"}
                        </span>
                      </Pill>
                    </TagWithBadge>
                  ))}

                {patient_experience
                  .filter(
                    (item) =>
                      item.label !== "Appointment Wait Times" &&
                      item.label != "Cancer Navigation Program" &&
                      item.values !== "-",
                  )
                  .map((item) => (
                    <TagWithBadge key={item.label}>
                      {item.label}
                      <PillNumber
                        bg={
                          item.values === "-"
                            ? "#F34D4D"
                            : item.values.toLowerCase() === "average"
                              ? "#F6B51C"
                              : item.values.toLowerCase() === "low"
                                ? "#F34D4D"
                                : "#61C676"
                        }
                      >
                        <span>{item.values === "-" ? "-" : item.values}</span>
                      </PillNumber>
                    </TagWithBadge>
                  ))}
              </>
            )}
          </TagContainer>
        </Section> */}
        {/* <Section>
          <RoundedBorder />
          <SectionTitle>Accessibility & Inclusivity</SectionTitle>
          <TagContainer>
            {accessibility_inclusivity
              .filter(
                (item) =>
                  item.label !== "Geographic Accessibility" && item.values[0] !== "-"
              )
              .map((item) => (
                <TagWithBadge key={item.label}>
                  {item.label}{" "}
                  <Pill status={item.values[0]}>
                    <span>{item.values[0] ? "Yes" : "No"}</span>
                  </Pill>
                </TagWithBadge>
              ))}

            {accessibility_inclusivity
              .filter(
                (item) => item.label === "Geographic Accessibility" && item.values[0] !== "-"
              )
              .map((item) => (
                <TagWithBadge key={item.label}>
                  {item.label}{" "}
                  <Pill bg={"#fff"} status={true}>
                    <span style={{ color: "#333" }}>{item.values[0]}</span>
                  </Pill>
                </TagWithBadge>
              ))}
          </TagContainer>
        </Section> */}
      </ScrollWrapper>
    </MainContainer>
  );
};

export default FactSheetLeft;
